/**
 * --------------------------------------------------------------------------
 * Custom Tooltips for Chart.js (v4.0.0-alpha.0): index.umd.js
 * Licensed under MIT (https://github.com/coreui/coreui-chartjs/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

// eslint-disable-next-line no-unused-vars
import customTooltips from './src/custom-tooltips.js'

export default {
  customTooltips
}
